import { IApplicationPayment } from '@/apis/apps/interfaces'
import type { IPaymentCharge } from '@/store/payment/interfaces'

export const calculateChargePrice = ({
  charge,
  agentsCount,
  payment,
}: {
  charge: IPaymentCharge
  agentsCount: number
  payment?: IApplicationPayment | null
}): {
  taxRate: number
  unitPrice: number
  unitPriceTax: number
  totalPrice: number
  totalPriceTax: number
  baseTotalPrice: number
  baseUnitPrice: number
} => {
  const agentsMultiplier = charge?.per_account ? agentsCount : 1
  const taxes = charge?.taxes

  let unitPrice = charge?.price || payment?.price || 0
  let totalPrice = unitPrice * agentsMultiplier
  let totalPriceTax = 0
  let unitPriceTax = 0
  let taxRate = 0
  const baseTotalPrice = totalPrice
  const baseUnitPrice = unitPrice

  if (taxes) {
    totalPrice = taxes.total_price
    unitPrice = totalPrice / agentsMultiplier
    totalPriceTax = taxes.tax_value
    unitPriceTax = totalPriceTax / agentsMultiplier
    taxRate = taxes.tax_rate * 100
  }

  return {
    taxRate,
    unitPrice,
    unitPriceTax,
    totalPrice,
    totalPriceTax,
    baseTotalPrice,
    baseUnitPrice,
  }
}

export const calculateUpdatedChargePrice = (price: number, months: number) => {
  const discount = months === 12 ? 0.85 : 1

  // Make sure it won't return a float number, as the price is already represented in cents
  return Math.floor(price * discount * months)
}
